import { NavLink, Link } from 'react-router';
import { Search } from 'lucide-react';
import { Logo } from '@/ui/Logo';
import { openPalette } from '@/store/ui';
import { InstallButton } from '@/pwa/InstallButton';
import { WalletButton } from '@/wallet/WalletButton';

export function BrandHeader() {
  return <header className="raydius-header">
    <Link to="/" aria-label="Raydius home"><Logo mark={34} /></Link>
    <nav className="glass-nav" aria-label="Main navigation"><NavLink to="/" end>Origin<span /></NavLink><NavLink to="/explore">Explore<span /></NavLink><NavLink to="/create">Launch<span /></NavLink></nav>
    <div className="header-right"><InstallButton /><button className="brand-search" onClick={openPalette} aria-label="Search coins and wallets" title="Search (Ctrl / ⌘ K)"><Search size={16} strokeWidth={1.6} /></button><WalletButton /></div>
  </header>;
}
